// extracted by mini-css-extract-plugin
export default {"form":"form-form-NHBrHv","formErrors":"form-formErrors-rYbgPi","submitButton":"form-submitButton-OGOxbc","cancelButton":"form-cancelButton-HVKcVS"};